import { forwardRef } from 'react';
import { getSidebarMenuStyles, getSidebarMenuSectionStyles } from './SidebarMenuStyles.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';

const SidebarMenu = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    header,
    footer,
    children,
    elevationValue = 'above',
    size,
    ...rest
  } = _ref;
  return jsxs("aside", {
    css: getSidebarMenuStyles(elevationValue, size),
    ref: ref,
    ...rest,
    children: [header, jsx("section", {
      css: getSidebarMenuSectionStyles(),
      children: children
    }), footer]
  });
});
SidebarMenu.displayName = 'SidebarMenu';

export { SidebarMenu };
//# sourceMappingURL=SidebarMenu.js.map
